import { render, staticRenderFns } from "./NetlinkInternationalTable.vue?vue&type=template&id=0535ecff"
import script from "./NetlinkInternationalTable.vue?vue&type=script&lang=js"
export * from "./NetlinkInternationalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports